import { ACCOUNT_STATUS } from '@client/actions';
import { Action } from '@client/lib/action';
import { AccountStatusState } from '@client/utils/shared-constants';

export class AccountStatusHydrateAction implements Action {
	readonly type = ACCOUNT_STATUS.HYDRATE;
	constructor(public payload?: null, public correlationId?: number) {}
}

export class AccountStatusHydrateFailureAction implements Action {
	readonly type = ACCOUNT_STATUS.HYDRATE_FAILURE;
	constructor(public payload: any, public correlationId?: number) {}
}

export class AccountStatusHydrateSuccessAction implements Action {
	readonly type = ACCOUNT_STATUS.HYDRATE_SUCCESS;
	constructor(public payload: AccountStatusState, public correlationId?: number) {}
}

export class AccountStatusUpdateAction implements Action {
	readonly type = ACCOUNT_STATUS.UPDATE;
	constructor(public payload: any, public correlationId?: number) {}
}
